import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import {
  type TestSendContactPointResult,
  zodTestSendContactPointResultSchema,
} from './validations';

/**
 * Sends a sample event to the saved receiver, nothing goes to the execution log
 *
 * @param contactPointId - The id of the saved contact point to test.
 * @returns A promise that resolves with the receiver's answer.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Subscription
 */
export const testSendContactPoint = async (
  contactPointId: UUID,
): Promise<TestSendContactPointResult> => {
  const response = await vestigasApi
    .post(ENDPOINT.DATA_SUBSCRIPTION.TEST_SEND_CONTACT_POINT(contactPointId))
    .json();

  // Fails on an unexpected shape instead of rendering half a result
  return zodTestSendContactPointResultSchema.parse(response);
};
